import { render, staticRenderFns } from "./AccettazioneSsnGruppiConfigListPage.vue?vue&type=template&id=61214204"
import script from "./AccettazioneSsnGruppiConfigListPage.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnGruppiConfigListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports